export const POST_COMMENTS_BEGIN = "POST_COMMENTS_BEGIN";
export const POST_COMMENTS_SUCCESS = "POST_COMMENTS_SUCCESS";
export const POST_COMMENTS_FAIL = "POST_COMMENTS_FAIL";

export const GET_COMMENTS_BEGIN = "GET_COMMENTS_BEGIN";
export const GET_COMMENTS_SUCCESS = "GET_COMMENTS_SUCCESS";
export const GET_COMMENTS_FAIL = "GET_COMMENTS_FAIL";